export type Locale = "vi" | "en";

export const LOCALES: { code: Locale; label: string; nativeLabel: string }[] = [
  { code: "vi", label: "Vietnamese", nativeLabel: "Tiếng Việt" },
  { code: "en", label: "English", nativeLabel: "English" },
];

export const DEFAULT_LOCALE: Locale = "vi";
export const LOCALE_STORAGE_KEY = "printer:locale";

export type TranslateParams = Record<string, string | number>;

export type TranslateFn = (key: string, params?: TranslateParams) => string;
